import { CircleCheck } from 'lucide-preact';

import { Wrapper } from '@/components/wrapper/wrapper';

interface SuccessBannerProps {
  onOpenChat: () => void;
}

export function SuccessBanner({ onOpenChat }: SuccessBannerProps) {
  return (
    <Wrapper className='!border-[#22c55e]/50'>
      <div className='flex items-center justify-between gap-3'>
        <div className='flex items-center gap-2'>
          <CircleCheck
            className='size-5 shrink-0 text-[#22c55e]'
            strokeWidth={2}
          />
          <span className='text-sm font-medium text-[#16a34a]'>
            Váš chatbot byl úspěšně natrénován!
          </span>
        </div>
        <button
          data-cta='web-input-open-chat-button'
          className='inline-flex shrink-0 items-center justify-center gap-2 rounded-2xl border border-[#9c70ff] bg-transparent px-4 py-2 text-sm font-medium text-[#9c70ff] transition-all hover:bg-[#9c70ff] hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#9c70ff]/50'
          onClick={onOpenChat}
          type='button'
        >
          Otevřít chat
        </button>
      </div>
    </Wrapper>
  );
}
